__turbopack_context__.v({
  "RequestQuoteCopyright": "property1-desktop-module-scss-module__uE-HvW__RequestQuoteCopyright",
  "about": "property1-desktop-module-scss-module__uE-HvW__about",
  "aboutParent": "property1-desktop-module-scss-module__uE-HvW__aboutParent",
  "aboutSubmenu": "property1-desktop-module-scss-module__uE-HvW__aboutSubmenu",
  "agriculture": "property1-desktop-module-scss-module__uE-HvW__agriculture",
  "aircraftManagement": "property1-desktop-module-scss-module__uE-HvW__aircraftManagement",
  "aircraftSales": "property1-desktop-module-scss-module__uE-HvW__aircraftSales",
  "allwights": "property1-desktop-module-scss-module__uE-HvW__allwights",
  "antDesigninstagramFilledIcon": "property1-desktop-module-scss-module__uE-HvW__antDesigninstagramFilledIcon",
  "availableFleet": "property1-desktop-module-scss-module__uE-HvW__availableFleet",
  "blogPress": "property1-desktop-module-scss-module__uE-HvW__blogPress",
  "careers": "property1-desktop-module-scss-module__uE-HvW__careers",
  "charterFlights": "property1-desktop-module-scss-module__uE-HvW__charterFlights",
  "charterFlightsParent": "property1-desktop-module-scss-module__uE-HvW__charterFlightsParent",
  "charterQuotes": "property1-desktop-module-scss-module__uE-HvW__charterQuotes",
  "charterSubmenu": "property1-desktop-module-scss-module__uE-HvW__charterSubmenu",
  "charterheraflightcom": "property1-desktop-module-scss-module__uE-HvW__charterheraflightcom",
  "contacts": "property1-desktop-module-scss-module__uE-HvW__contacts",
  "contacts1": "property1-desktop-module-scss-module__uE-HvW__contacts1",
  "contacts2": "property1-desktop-module-scss-module__uE-HvW__contacts2",
  "dot": "property1-desktop-module-scss-module__uE-HvW__dot",
  "emptyLegFlights": "property1-desktop-module-scss-module__uE-HvW__emptyLegFlights",
  "ezlogz1": "property1-desktop-module-scss-module__uE-HvW__ezlogz1",
  "federalLocal": "property1-desktop-module-scss-module__uE-HvW__federalLocal",
  "flyHera": "property1-desktop-module-scss-module__uE-HvW__flyHera",
  "flyHeraParent": "property1-desktop-module-scss-module__uE-HvW__flyHeraParent",
  "foodBeverage": "property1-desktop-module-scss-module__uE-HvW__foodBeverage",
  "footerLink": "property1-desktop-module-scss-module__uE-HvW__footerLink",
  "footerinfo": "property1-desktop-module-scss-module__uE-HvW__footerinfo",
  "footermenu": "property1-desktop-module-scss-module__uE-HvW__footermenu",
  "footermenuParent": "property1-desktop-module-scss-module__uE-HvW__footermenuParent",
  "headerTop": "property1-desktop-module-scss-module__uE-HvW__headerTop",
  "inquiriesSales": "property1-desktop-module-scss-module__uE-HvW__inquiriesSales",
  "jetCard": "property1-desktop-module-scss-module__uE-HvW__jetCard",
  "jetCardParent": "property1-desktop-module-scss-module__uE-HvW__jetCardParent",
  "links": "property1-desktop-module-scss-module__uE-HvW__links",
  "mail1block": "property1-desktop-module-scss-module__uE-HvW__mail1block",
  "mail2block": "property1-desktop-module-scss-module__uE-HvW__mail2block",
  "management": "property1-desktop-module-scss-module__uE-HvW__management",
  "mdilinkedinIcon": "property1-desktop-module-scss-module__uE-HvW__mdilinkedinIcon",
  "passengerBus": "property1-desktop-module-scss-module__uE-HvW__passengerBus",
  "phone": "property1-desktop-module-scss-module__uE-HvW__phone",
  "phoneLink": "property1-desktop-module-scss-module__uE-HvW__phoneLink",
  "phoneblock": "property1-desktop-module-scss-module__uE-HvW__phoneblock",
  "primetwitterIcon": "property1-desktop-module-scss-module__uE-HvW__primetwitterIcon",
  "privacyPolicy": "property1-desktop-module-scss-module__uE-HvW__privacyPolicy",
  "property1desktop": "property1-desktop-module-scss-module__uE-HvW__property1desktop",
  "raceTeam": "property1-desktop-module-scss-module__uE-HvW__raceTeam",
  "rifacebookFillIcon": "property1-desktop-module-scss-module__uE-HvW__rifacebookFillIcon",
  "rightcol": "property1-desktop-module-scss-module__uE-HvW__rightcol",
  "schoolBus": "property1-desktop-module-scss-module__uE-HvW__schoolBus",
  "section1": "property1-desktop-module-scss-module__uE-HvW__section1",
  "section2": "property1-desktop-module-scss-module__uE-HvW__section2",
  "services": "property1-desktop-module-scss-module__uE-HvW__services",
  "servicesParent": "property1-desktop-module-scss-module__uE-HvW__servicesParent",
  "servicesSubmenu": "property1-desktop-module-scss-module__uE-HvW__servicesSubmenu",
  "socialIcons": "property1-desktop-module-scss-module__uE-HvW__socialIcons",
  "socialLink": "property1-desktop-module-scss-module__uE-HvW__socialLink",
  "socials": "property1-desktop-module-scss-module__uE-HvW__socials",
  "subFooter": "property1-desktop-module-scss-module__uE-HvW__subFooter",
  "termsConditions": "property1-desktop-module-scss-module__uE-HvW__termsConditions",
  "topblock": "property1-desktop-module-scss-module__uE-HvW__topblock",
  "vipheraflightcom": "property1-desktop-module-scss-module__uE-HvW__vipheraflightcom",
});
